import React from 'react'
import Header from '../../component/Header'
import AboutUs from '../AboutUs'
import Footer from '../../component/Footer'
import CourseMSC from '../CourseMSC'

export default function LayoutCourseMSC() {
    return (
        <div>
            <Header />
            <CourseMSC />
            <Footer />
        </div>
    )
}
